<template>
  <div>
    <div
      class="modal fade"
      id="instacartPopUp"
      tabindex="-1"
      role="dialog"
      aria-labelledby="openModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content campaign-g-addedit"
          style="width: 1000px; height: 260px; margin-left: -49px"
        >
          <div class="modal-header" style="flex: 0 0 auto">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Add Instacart
            </h5>
            <button type="button" class="close" @click="resetInstacart" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin-top: 25px">
            <div
              class="spinner-border"
              v-if="isLoading"
              style="margin: auto; display: block; margin-top: 60px"
            />
            <div v-else>
              <form v-on:submit.prevent ref="instacart">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"
                    >Instacart Account Name <sup>*</sup></label
                  >
                  <div class="col-sm-7 pr-5">
                    <input
                      type="text"
                      name="instacartAccountName"
                      v-model="instacart.instacart_profile_name"
                      class="form-control"
                      id="instacartName_id"
                      placeholder="Instacart Account Name"
                      style="height: 40px"
                      v-on:input="checkDuplicasyName($event)"
                    />
                    <span
                      class="no-data-style"
                      v-if="
                        instacart &&
                        !instacart.instacart_profile_name &&
                        isSubmitted
                      "
                    >
                      Provide the required field
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"
                    >Instacart Profile Id <sup>*</sup></label
                  >
                  <div class="col-sm-7 pr-5">
                    <!-- <span class="no-data-style" v-if="alreadyExistData">
                      Instacart with same id already exist, please choose another.
                    </span> -->
                    <input
                      type="text"
                      name="instacartAccountId"
                      v-model="instacart.instacart_profile_id"
                      class="form-control"
                      id="instacartProfile_id"
                      placeholder="Instacart Profile Id"
                      style="height: 40px"
                      v-on:input="checkDuplicasyId($event)"
                    />
                    
                    <span
                      class="no-data-style"
                      v-if="
                        instacart &&
                        !instacart.instacart_profile_id &&
                        isSubmitted
                      "
                    >
                      Provide the required field
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">
                    </label>
                  <div class="col-sm-7 pr-5">
                    <p class="no-data-style" v-if="alreadyExistName">
                      Instacart with same name already exist, please choose another.
                    </p>
                    <p class="no-data-style" v-if="alreadyExistData">
                      Instacart with same id already exist, please choose another.
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer" style="flex: 0 0 auto">
            <div class="mt-2" style="text-align: center">
              <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "resetAction()">Cancel</button> -->
              <button
                type="button"
                class="btn btn-primary"
                @click="saveInstacart()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  name: "InstacartPopUp",
  props: [
    "selectedInstacartIndex",
    "index",
    "instacartList",
  ],
  data() {
    return {
      instacart: {
        instacart_profile_name: "",
        instacart_profile_id: "",
        active: true,
        disable_date: null,
      },
      alreadyExistData: false,
      alreadyExistName:false,
      isLoading: false,
      isSubmitted : false
    };
  },
  methods: {
    saveInstacart() {
      this.isSubmitted = true
      if (this.alreadyExistData == false && this.alreadyExistName == false && this.instacart.instacart_profile_name.trim() && this.instacart.instacart_profile_id.trim()) {
        let vm = this;
        this.isLoading = true;
        let payload = {
          instacart: this.instacart
        };
        this.$store.dispatch("accounts/saveInstacart", payload).then((res) => {
          if (res && Object.keys(res).length != 0) {
            this.isLoading = false;
            vm.$emit("updateAddedInstacartInfo", res.data, vm.index);
            vm.resetInstacart()
          } 
        });
      }
    },
    resetInstacart(){
      this.instacart= {
        instacart_profile_name: "",
        instacart_profile_id: "",
        active: true,
        disable_date: null,
      },
      this.alreadyExistData= false,
      this.alreadyExistName=false,
      this.isLoading= false,
      this.isSubmitted = false
    },
    validate() {
      let checkDuplicate = this.$refs["instacart"].alreadyExistData;

      if (
        !this.instacart.instacart_profile_id ||
        checkDuplicate ||
        !this.instacart.merchant_name
      ) {
        this.$refs["instacart"].validate(true);
        return false;
      } else {
        this.$refs["instacart"].validate(false);
        return true;
      }
    },
    checkDuplicasyId(eventData) {
      if (eventData.currentTarget.value.trim().length) {
        this.alreadyExistData = false;
        this.isSubmitted = false;
        let existingData = this.instacartList.find(
          (e) =>
            this.instacart.instacart_profile_id.toLowerCase().trim() ==
            e.instacart_profile_id.toLowerCase().trim()
        );

        if (existingData) {
          this.alreadyExistData = true;
        }
      } else {
        this.alreadyExistData = false;
        eventData.currentTarget.value = eventData.currentTarget.value.trim();
        this.instacart.instacart_profile_id = this.instacart.instacart_profile_id.trim();
      }
    },
    checkDuplicasyName(eventData) {
      if (eventData.currentTarget.value.trim().length) {
        this.alreadyExistName = false;
        this.isSubmitted = false;
        let existingData = this.instacartList.find(
          (e) =>
            this.instacart.instacart_profile_name.toLowerCase().trim() ==
            e.instacart_profile_name.toLowerCase().trim()
        );

        if (existingData) {
          this.alreadyExistName = true;
        }
      } else {
        this.alreadyExistName = false;
        eventData.currentTarget.value = eventData.currentTarget.value.trim();
        this.instacart.instacart_profile_name = this.instacart.instacart_profile_name.trim();
      }
    }
  },
  Component: {
    moment,
  },
};
</script>
